import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';

@Component({
  selector: 'app-weekday-editor',
  templateUrl: './weekday-editor.component.html',
  styleUrls: ['./weekday-editor.component.scss']
})
export class WeekdayEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
  ) {

    this.detailsFormGroup.addControl('weekdayMonday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdayTuesday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdayWednesday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdayThursday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdayFriday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdaySaturday', new FormControl('', []));
    this.detailsFormGroup.addControl('weekdaySunday', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.weekdayMonday = this.detailsFormGroup.controls.weekdayMonday.value === true;
          this.condition.data.weekdayTuesday = this.detailsFormGroup.controls.weekdayTuesday.value === true;
          this.condition.data.weekdayWednesday = this.detailsFormGroup.controls.weekdayWednesday.value === true;
          this.condition.data.weekdayThursday = this.detailsFormGroup.controls.weekdayThursday.value === true;
          this.condition.data.weekdayFriday = this.detailsFormGroup.controls.weekdayFriday.value === true;
          this.condition.data.weekdaySaturday = this.detailsFormGroup.controls.weekdaySaturday.value === true;
          this.condition.data.weekdaySunday = this.detailsFormGroup.controls.weekdaySunday.value === true;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }

}
